import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

/** inboxes的渠道枚举 */
export const INBOX_CHANNEL = {
  /** 私信收件箱ID */
  PRIVATE_MESSAGE: 'privateMessageInboxIds',
  // INS_PRIVATE_MESSAGE: 'insPrivateMessageInboxIds',
  /** INS私信收件箱ID */
  INS_PRIVATE_MESSAGE: 'insPrivateMessageInboxId',
  /** Savana IQ收件箱ID */
  IQ_SAVANA: 'iqSavanaInboxId',
  /** INS评论收件箱ID */
  INS_COMMENT: 'insCommentInboxId',
  /** facebook私信收件箱ID */
  FB_PRIVATE_MESSAGE: 'fbPrivateMessageInboxId',
  /** facebook评论收件箱ID */
  FB_COMMENT: 'fbCommentInboxId',
  /** needPrecheckInboxIds */
  NEED_PRECHECK: 'needPrecheckInboxIds',
  /** GooglePlay收件箱ID */
  GOOGLE_PLAY: 'googlePlayInboxId',
  /** AppStore收件箱ID */
  APP_STORE: 'appStoreInboxId',
  /** Email收件箱ID */
  EMAIL: 'emailInboxId',
  /** TikTok评论收件箱ID */
  TIK_TOK_COMMENT: 'tikTokCommentInboxId',
};

/** 获取当前会话的 inboxId */
export function useInboxId() {
  const currentChat = useMapGetter('getSelectedChat');
  const inboxId = computed(() => currentChat.value?.inbox_id);
  return inboxId;
}

/** 获取当前会话的 站内用户userId */
export function useInAppUserId() {
  const currentChat = useMapGetter('getSelectedChat');
  const inAppUserId = computed(() => currentChat.value?.meta?.sender?.additional_attributes.userId);
  return inAppUserId;
}

/** 获取当前会话的 是否为站内匿名用户 */
export function useIsInAppAnonymousUser() {
  const inAppUserId = useInAppUserId();
  return inAppUserId.value === 0;
}

/** 获取当前会话的 是否为站内注册用户 */
export function useIsInAppRegisteredUser() {
  const inAppUserId = useInAppUserId();
  return inAppUserId.value && inAppUserId.value !== 0;
}

function isChannel(inboxChannel, inboxId) {
  return String(inboxId) === window.urConfig.inboxInfo[inboxChannel];
}

/** 
 * 判断当前会话是否属于指定的渠道。  
 * @param inboxChannel 渠道枚举{@linkcode INBOX_CHANNEL}
 */
export function useIsChannel(inboxChannel) {
  const inboxId = useInboxId();
  if (Array.isArray(inboxChannel)) {
    return inboxChannel.some(channel => isChannel(channel, inboxId.value));
  }
  return isChannel(inboxChannel, inboxId.value);
}
